<template>
    <div class="co-novo-documento-signatario-chave-seguranca">        
        <v-text-field
            v-model="value.chaveSeguranca"
            :error-messages="errors.collect('Chave de seguranca')"
            name="chave"
            class="pt-0 mt-0"
            persistent-placeholder
            :disabled="disabled"
            :outlined="outlined"
        >
            <template v-slot:label>
                <span class="mr-1">Chave de segurança</span>
                <icon-info tamanhoIcon="18" :descricao-campo="descricaoCampo"/>
            </template>
        </v-text-field>
    </div>
</template>

<script>

import IconInfo from '@/views/criar-documento/novo-documento-signatario/components/IconInfo'

export default {
    name: 'ChaveSegurancaNovo',
    components: {IconInfo},
    props: {
        value: {
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            descricaoCampo: 'Aqui você pode definir uma chave de segurança que só você e o '+ 
                this.$tc("pt_br.signatario").toLowerCase() + ' saberão. Isso é uma medida para dar mais segurança ao processo de' +
                ' assinatura, garantindo que outra pessoa não conseguirá assinar no lugar deste ' + this.$tc("pt_br.signatario").toLowerCase() + '.'
        }
    }
}
</script>

<style lang="stylus">
.co-novo-documento-signatario-chave-seguranca
    position relative
    width 100%

    .icon-info
        padding-bottom 0 !important

    .chave-seguranca-field
        padding-top 0
        margin-top 0

    .label
        color var(--text-color-300)

</style>